export const PERMISSIONS = {
  ASSIGN_ADMIN_ROLE: 'assign_admin_role',
  ASSIGN_EDITOR_ROLE: 'assign_editor_role',
  CREATE_CLIENT: 'create_client',
  VIEW_CLIENT: 'view_client',
  DELETE_CLIENT: 'delete_client',
  VIEW_MANAGEMENT: [
    'view_client',
    'view_information_unit_tag',
    'view_role',
    'view_tracking_search',
    'view_user',
    'a360plus_workspace_view_workspace',
  ],
  MANAGE_WORKSPACES: 'a360plus_workspace_view_workspace',
  CREATE_WORKSPACE: 'create_workspace',
  VIEW_WORKSPACE: 'view_workspace',
  DELETE_WORKSPACE: 'delete_workspace',
  CREATE_CONTACT: 'create_contact',
  VIEW_CONTACT: 'view_contact',
  DELETE_CONTACT: 'delete_contact',
  VIEW_INFORMATION_UNIT: 'view_information_unit',
  UPDATE_INFORMATION_UNIT: 'update_information_unit',
  DELETE_INFORMATION_UNIT: 'delete_information_unit',
  VALIDATE_INFORMATION_UNIT: 'validate_information_unit',
  CREATE_INFORMATION_UNIT_TAG: 'create_information_unit_tag',
  VIEW_INFORMATION_UNIT_TAG: 'view_information_unit_tag',
  DELETE_INFORMATION_UNIT_TAG: 'delete_information_unit_tag',
  CREATE_THEME: 'create_theme',
  VIEW_THEME: 'view_theme',
  DELETE_THEME: 'delete_theme',
  CREATE_DOSSIER: 'create_dossier',
  VIEW_DOSSIER: 'view_dossier',
  DELETE_DOSSIER: 'delete_dossier',
  CREATE_DOSSIER_TEMPLATE: 'create_dossier_template',
  VIEW_DOSSIER_TEMPLATE: 'view_dossier_template',
  DELETE_DOSSIER_TEMPLATE: 'delete_dossier_template',
  CREATE_DOSSIER_MAILING_TEMPLATE: 'create_dossier_mailing_template',
  VIEW_DOSSIER_MAILING_TEMPLATE: 'view_dossier_mailing_template',
  DELETE_DOSSIER_MAILING_TEMPLATE: 'delete_dossier_mailing_template',
  CREATE_SHARED_LINK: 'create_shared_link',
  VIEW_SHARED_LINK: 'view_shared_link',
  DELETE_SHARED_LINK: 'delete_shared_link',
  CREATE_TRACKING_SEARCH: 'create_tracking_search',
  UPDATE_TRACKING_SEARCH: 'update_tracking_search',
  VIEW_TRACKING_SEARCH: 'view_tracking_search',
  DELETE_TRACKING_SEARCH: 'delete_tracking_search',
  PREVIEW_TRACKING_SEARCH: 'preview_tracking_search',
  VIEW_TRACKING_SEARCH_RETROSPECT: 'view_tracking_search_retrospect',
  CREATE_TRACKING_SEARCH_RETROSPECT: 'create_tracking_search_retrospect',
  CANCEL_TRACKING_SEARCH_RETROSPECT: 'cancel_tracking_search_retrospect',
  VIEW_PROGRAM: 'view_program',
  VIEW_CHANNEL: 'view_channel',
  VIEW_MEDIA: 'view_media',
  VIEW_PUBLISHING_GROUP: 'view_publishing_group',
  VIEW_SECTION: 'view_section',
  CREATE_EXTERNAL_SOURCE_QUERY: 'create_external_source_query',
  VIEW_EXTERNAL_SOURCE_QUERY: 'view_external_source_query',
  DELETE_EXTERNAL_SOURCE_QUERY: 'delete_external_source_query',
  CREATE_INFORMATION_UNIT_TAG_GROUP: 'create_information_unit_tag_group',
  VIEW_INFORMATION_UNIT_TAG_GROUP: 'view_information_unit_tag_group',
  DELETE_INFORMATION_UNIT_TAG_GROUP: 'delete_information_unit_tag_group',
  CREATE_PROJECT: 'create_project',
  VIEW_PROJECT: 'view_project',
  DELETE_PROJECT: 'delete_project',
  CREATE_PROJECT_TAG_GROUP: 'create_project_tag_group',
  VIEW_PROJECT_TAG_GROUP: 'view_project_tag_group',
  DELETE_PROJECT_TAG_GROUP: 'delete_project_tag_group',
  VIEW_REPOSITORY: [
    'view_dossier',
    'view_dossier_template',
    'view_dossier_mailing_template',
    'view_theme',
  ],
  VIEW_CONFIGURATION: [
    'view_workspace',
    'view_project',
    'assign_admin_role',
    'assign_editor_role',
    'assign_viewer_role',
    'view_contact',
    'view_information_unit_tag',
    'view_information_unit_tag_group',
    'view_tracking_search',
    'view_external_source_query',
  ],
  MANAGE_USERS: ['manage_users'],
  VIEW_USER: 'view_user',
  CREATE_USER: 'create_user',
  DELETE_USER: 'delete_user',
  UPDATE_USER: 'update_user',
  VIEW_ROLE: 'view_role',
  CREATE_ROLE: 'create_role',
  UPDATE_ROLE: 'update_role',
  DELETE_ROLE: 'delete_role',
  CREATE_DOSSIER_PUBLICATION: 'create_dossier_publication',
  VIEW_DOSSIER_PUBLICATION: 'view_dossier_publication',
  DELETE_DOSSIER_PUBLICATION: 'delete_dossier_publication',
  CREATE_ALERT: 'create_alert_publication',
  VIEW_ALERT: 'view_alert_publication',
  DELETE_ALERT: 'delete_alert_publication',
  CREATE_EXPORT: 'create_export_publication',
  VIEW_EXPORT: 'view_export_publication',
  DELETE_EXPORT: 'delete_export_publication',
  CREATE_HTTP: 'create_http_api_publication',
  VIEW_HTTP: 'view_http_api_publication',
  DELETE_HTTP: 'delete_http_api_publication',
  MEDIA_MANAGER: {
    ACCESS: 'media_manager_access',
    CREATE_LOGO: 'media_manager_create_logo',
    VIEW_LOGO: 'media_manager_view_logo',
    DELETE_LOGO: 'media_manager_delete_logo',
    CREATE_PERSON: 'media_manager_create_person',
    VIEW_PERSON: 'media_manager_view_person',
    DELETE_PERSON: 'media_manager_delete_person',
    CREATE_AUDIENCE_DATA: 'media_manager_create_audience_data',
    VIEW_AUDIENCE_DATA: 'media_manager_view_audience_data',
    DELETE_AUDIENCE_DATA: 'media_manager_delete_audience_data',
    CREATE_ECONOMIC_VALUE_DATA: 'media_manager_create_economic_value_data',
    VIEW_ECONOMIC_VALUE_DATA: 'media_manager_view_economic_value_data',
    DELETE_ECONOMIC_VALUE_DATA: 'media_manager_delete_economic_value_data',
    CREATE_PRODUCTION_CENTER: 'media_manager_create_production_center',
    VIEW_PRODUCTION_CENTER: 'media_manager_view_production_center',
    DELETE_PRODUCTION_CENTER: 'media_manager_delete_production_center',
    CREATE_CHANNEL: 'media_manager_create_channel',
    VIEW_CHANNEL: 'media_manager_view_channel',
    DELETE_CHANNEL: 'media_manager_delete_channel',
    CREATE_CHANNEL_RECORDING_SCHEDULE: 'media_manager_create_channel_recording_schedule',
    VIEW_CHANNEL_RECORDING_SCHEDULE: 'media_manager_view_channel_recording_schedule',
    DELETE_CHANNEL_RECORDING_SCHEDULE: 'media_manager_delete_channel_recording_schedule',
    CREATE_CHANNEL_RECORDING: 'media_manager_create_channel_recording',
    VIEW_CHANNEL_RECORDING: 'media_manager_view_channel_recording',
    DELETE_CHANNEL_RECORDING: 'media_manager_delete_channel_recording',
    CREATE_PROGRAM: 'media_manager_create_program',
    VIEW_PROGRAM: 'media_manager_view_program',
    DELETE_PROGRAM: 'media_manager_delete_program',
    CREATE_PROGRAM_BROADCAST: 'media_manager_create_program_broadcast',
    VIEW_PROGRAM_BROADCAST: 'media_manager_view_program_broadcast',
    DELETE_PROGRAM_BROADCAST: 'media_manager_delete_program_broadcast',
    UPDATE_PROGRAM_BROADCAST_INTERVAL: 'media_manager_update_program_broadcast_interval',
    CREATE_SEGMENT: 'media_manager_create_segment',
    VIEW_SEGMENT: 'media_manager_view_segment',
    DELETE_SEGMENT: 'media_manager_delete_segment',
    CREATE_SEGMENT_LOGO: 'media_manager_create_segment_logo',
    VIEW_SEGMENT_LOGO: 'media_manager_view_segment_logo',
    DELETE_SEGMENT_LOGO: 'media_manager_delete_segment_logo',
    CREATE_SEGMENT_STATEMENT: 'media_manager_create_segment_statement',
    VIEW_SEGMENT_STATEMENT: 'media_manager_view_segment_statement',
    DELETE_SEGMENT_STATEMENT: 'media_manager_delete_segment_statement',
    CREATE_SEGMENT_PERSON: 'media_manager_create_segment_person',
    VIEW_SEGMENT_PERSON: 'media_manager_view_segment_person',
    DELETE_SEGMENT_PERSON: 'media_manager_delete_segment_person',
    CREATE_SEGMENT_TRANSCRIPTION: 'media_manager_create_segment_transcription',
    VIEW_SEGMENT_TRANSCRIPTION: 'media_manager_view_segment_transcription',
    DELETE_SEGMENT_TRANSCRIPTION: 'media_manager_delete_segment_transcription',
    CREATE_SEGMENT_TEXT_ON_SCREEN: 'media_manager_create_segment_text_on_screen',
    VIEW_SEGMENT_TEXT_ON_SCREEN: 'media_manager_view_segment_text_on_screen',
    DELETE_SEGMENT_TEXT_ON_SCREEN: 'media_manager_delete_segment_text_on_screen',
    CREATE_CLIP: 'media_manager_create_clip',
    VIEW_CLIP: 'media_manager_view_clip',
    DELETE_CLIP: 'media_manager_delete_clip',
    CREATE_CLIP_LOGO: 'media_manager_create_clip_logo',
    VIEW_CLIP_LOGO: 'media_manager_view_clip_logo',
    DELETE_CLIP_LOGO: 'media_manager_delete_clip_logo',
    CREATE_CLIP_STATEMENT: 'media_manager_create_clip_statement',
    VIEW_CLIP_STATEMENT: 'media_manager_view_clip_statement',
    DELETE_CLIP_STATEMENT: 'media_manager_delete_clip_statement',
    CREATE_CLIP_PERSON: 'media_manager_create_clip_person',
    VIEW_CLIP_PERSON: 'media_manager_view_clip_person',
    DELETE_CLIP_PERSON: 'media_manager_delete_clip_person',
    CREATE_CLIP_TRANSCRIPTION: 'media_manager_create_clip_transcription',
    VIEW_CLIP_TRANSCRIPTION: 'media_manager_view_clip_transcription',
    DELETE_CLIP_TRANSCRIPTION: 'media_manager_delete_clip_transcription',
    CREATE_CLIP_TEXT_ON_SCREEN: 'media_manager_create_clip_text_on_screen',
    VIEW_CLIP_TEXT_ON_SCREEN: 'media_manager_view_clip_text_on_screen',
    DELETE_CLIP_TEXT_ON_SCREEN: 'media_manager_delete_clip_text_on_screen',
    VIEW_SPONSORSHIP_REPORT: 'media_manager_view_sponsorship_report',
    CREATE_TIME_KEEPING_SESSION: 'media_manager_create_time_keeping_session',
    VIEW_TIME_KEEPING_SESSION: 'media_manager_view_time_keeping_session',
    DELETE_TIME_KEEPING_SESSION: 'media_manager_delete_time_keeping_session',
    CREATE_CNMC_REPORT: 'media_manager_create_cnmc_report',
    VIEW_CNMC_REPORT: 'media_manager_view_cnmc_report',
    DELETE_CNMC_REPORT: 'media_manager_delete_cnmc_report',
  },
};

export const PERMISSIONS_MENU = {
  SOURCES: [
    PERMISSIONS.MEDIA_MANAGER.VIEW_PRODUCTION_CENTER,
    PERMISSIONS.MEDIA_MANAGER.VIEW_CHANNEL,
  ],
  MANAGEMENT: [
    PERMISSIONS.MEDIA_MANAGER.VIEW_CHANNEL_RECORDING_SCHEDULE,
    PERMISSIONS.MEDIA_MANAGER.VIEW_CHANNEL_RECORDING,
    PERMISSIONS.MEDIA_MANAGER.VIEW_PROGRAM,
  ],
  ENRICHMENTS: [
    PERMISSIONS.MEDIA_MANAGER.VIEW_PERSON,
    PERMISSIONS.MEDIA_MANAGER.VIEW_LOGO,
    PERMISSIONS.MEDIA_MANAGER.VIEW_AUDIENCE_DATA,
    PERMISSIONS.MEDIA_MANAGER.VIEW_ECONOMIC_VALUE_DATA,
    PERMISSIONS.MEDIA_MANAGER.VIEW_CNMC_REPORT,
  ],
  REVIEW: [PERMISSIONS.MEDIA_MANAGER.VIEW_SEGMENT, PERMISSIONS.MEDIA_MANAGER.VIEW_CLIP],
};
